import script from "./super-payroll-presets.vue?vue&type=script&setup=true&lang=js"
export * from "./super-payroll-presets.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__